export const isValidUpcInput = (upc: unknown) => {
  return typeof upc === "string" && upc.length > 0;
};

export const cleanUpc = (upc: string) => {
  return upc.replace(/\D/g, "");
};

export const getBarcodeFormat = (cleanedUpc: string) => {
  if (cleanedUpc.length === 12) return "UPC";
  if (cleanedUpc.length === 13) return "EAN13";
  if (cleanedUpc.length === 8) return "EAN8";
  return "CODE128";
};

export const getBarcodeSizing = (input: {
  isLarge: boolean;
  width: number;
  height: number;
  fontSize: number;
}) => {
  if (input.isLarge) {
    return { width: 3, height: 150, fontSize: 24 };
  }
  return {
    width: input.width,
    height: input.height,
    fontSize: input.fontSize,
  };
};
